module.exports = __webpack_public_path__ + "media/images/svgs/balls-icon-8bec8f087b9015876506178b77c3a4ae.svg";